<email-layout [showLogo]="false">
  <ng-container header>
    <email-message-header [header]="data().company_name" [separator]="false" />
    <email-margin [height]="18" />
    <email-text [contents]="data().message | mailgunMarkAsHtml" color="light" size="small" />
    <email-margin [height]="18" />
  </ng-container>

  <ng-container body>
    <div class="consent-request-box">
      <email-text [contents]="data().title" presetName="paragraph" size="large" [bold]="true" />
      <email-text [contents]="data().p1" size="small" color="light" />
      <email-margin [height]="12" />
      <email-button
        [href]="data().button_link"
        [label]="data().button_text"
        theme="primary"
        [inline]="true"
      />
    </div>
    <div class="consent-request-box-footer">
      <email-text
        [contents]="data().p2_html"
        size="small"
        color="light"
        className="web-rt-contains-link"
      />
    </div>
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data().footer_html"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
  </ng-container>
</email-layout>
